import type { FeatureIconKey, PillIconKey } from '@content/home/features';
import {
  BanknotesIcon,
  CalculatorIcon,
  ChartBarIcon,
  ClipboardDocumentListIcon,
  CreditCardIcon,
  DocumentTextIcon,
  InboxStackIcon,
  PlayCircleIcon,
  ServerIcon,
  ShieldCheckIcon,
  SparklesIcon,
  UserGroupIcon,
} from '@heroicons/react/20/solid';

export const ICONS: Record<FeatureIconKey, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  'user-group': UserGroupIcon,
  'inbox-stack': InboxStackIcon,
  clipboard: ClipboardDocumentListIcon,
  banknotes: BanknotesIcon,
  'document-text': DocumentTextIcon,
  'credit-card': CreditCardIcon,
  'shield-check': ShieldCheckIcon,
  'chart-bar': ChartBarIcon,
  calculator: CalculatorIcon,
  server: ServerIcon,
  sparkles: SparklesIcon,
} as const;

export const PILL_ICONS: Record<PillIconKey, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  'play-circle': PlayCircleIcon,
  sparkles: SparklesIcon,
} as const;
